const berechneAussere = (
  schichtenCalculated,
  bemessungslast,
  bemessungspfahlwiderstand,
  pfahllaengeGewaehltInBoden,
  minimalePfahllaenge
) => {
  // lastRdi
  let lastRdi = 0;
  for (let i = schichtenCalculated.length - 1; i >= 0; i--) {
    if (schichtenCalculated[i].liZeta != 0.0) {
      lastRdi = schichtenCalculated[i].rdi;
      break;
    }
  }
  // designedPileResistance
  let designedPileResistance = 0;
  designedPileResistance =
    Number(bemessungspfahlwiderstand) +
    (Number(pfahllaengeGewaehltInBoden) - Number(minimalePfahllaenge)) * Number(lastRdi);

  // utilizationFactor
  let utilizationFactor = 0;
  if (Number(bemessungslast) != 0) {
    utilizationFactor = Number(bemessungslast) / Number(designedPileResistance);
  }
  return { lastRdi, designedPileResistance, utilizationFactor };
};

export default berechneAussere;
